<mat-icon [svgIcon]="iconUrl" [attr.aria-label]="ariaLabel"></mat-icon>